module.exports = __webpack_public_path__ + "static/img/2bg_23.f6c506a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/2bg_23.png
// module id = 679
// module chunks = 1